export default "__VITE_ASSET__Bgv6dRpq__"